<section class="master_feed_sec extBg">
    <div class="new_feed_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="column"
        fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutGap="20px"
       >
        <div class="feed_right_column" fxLayout="column" fxFlex.xl="76" fxFlex.lg="76" fxFlex.md="100" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill>

            <div class="upload-media media icon-container" *ngIf="!(selectedUser || selectedCompany)"
                [hidden]="selectedUser" [hidden]="selectedCompany">
                <div class="media-left">
                    <img *ngIf="loginDetails?.type === 'ADMIN'" src="../../../../../assets/images2/logo.svg"
                        alt="Admin Icon" />
                    <img *ngIf="loginDetails?.type === 'SUPPLIER'" [src]=loginDetails?.logo?.url
                        alt="User Placeholder" />
                    <img *ngIf="loginDetails.type ==='PRACTICE'" [src]=loginDetails?.logo?.url alt="User Placeholder" />
                    <img *ngIf="loginDetails.type ==='PROFESSIONAL'" [src]=loginDetails?.profile_image?.url
                        alt="User Placeholder" />
                </div>
                <!--    <div class="media-body" (click)="openDialog()" style="margin-right: 10px;">
                    <div class="upload-tab">
                        <p>Write something here...</p>
                    </div>
                </div>
                -->
                <div class="media-body" (click)="handleNewsfeedClick()" style="margin-right: 10px;">
                    <div class="upload-tab">
                        <p>Write something here...</p>
                    </div>
                </div>
                <button mat-button [matMenuTriggerFor]="filterMenu" _ngcontent-serverapp-c517="" type="button"
                    (menuOpened)="loadCategories()" mat-button=""
                    class="mat-focus-indicator btn btn-sm bulk_filter_btn ng-tns-c517-9 mat-button mat-button-base">
                    <span class="mat-button-wrapper">
                        <span _ngcontent-serverapp-c517="" class="btn-content">{{selectedCategory ?
                            selectedCategory?.category_name : 'Filter By'}} </span>
                        <img _ngcontent-serverapp-c517="" src="../../../../../../../assets/images/icons/filterDown.png"
                            alt="">

                    </span>
                </button>
                <span *ngIf="selectedCategory" style="cursor: pointer;" (click)="removefilter()"> <i
                        _ngcontent-serverapp-c439="" class="material-icons">close</i> </span>
                <mat-menu #filterMenu="matMenu">
                    <button mat-menu-item *ngFor="let category of categories" (click)="selectCategory(category)">
                        {{ category?.category_name }}
                    </button>
                </mat-menu>

            </div>

            <!-- Selected User Details -->
            <div class="user-details-container" *ngIf="selectedUser"
                style="display: flex; align-items: center; gap: 10px; padding: -3px 100px;position: relative;">
                <button class="remove-icon" (click)="removesearch()">
                    <mat-icon>close</mat-icon>
                </button>
                <div style="display: flex; gap: 16px; align-items: center;">
                    <!-- Profile Image -->
                    <ng-container *ngIf="selectedUser?.profile_image?.url; else checkLogo">
                        <img [src]="selectedUser.profile_image.url" alt="User Image"
                            style="width: 40px; height: 40px; border-radius: 50%;" />
                    </ng-container>
                    <!-- Logo (if no profile image) -->
                    <ng-template #checkLogo>
                        <ng-container *ngIf="selectedUser?.logo?.url; else showInitials">
                            <img [src]="selectedUser.logo.url" alt="User Logo"
                                style="width: 40px; height: 40px; border-radius: 50%;" />
                        </ng-container>
                    </ng-template>
                    <!-- Fallback Initials (if no image or logo) -->
                    <ng-template #showInitials>
                        <div class="fallback-avatar">
                            {{ getInitials(selectedUser?.name) }}
                        </div>
                    </ng-template>
                    <div style="display: flex; flex-direction: column;">
                        <a (click)="goToDetails(selectedUser)">
                            <!-- <a> -->
                            <h6 class="user-name-detail"> {{ selectedUser?.name }}
                            </h6>
                        </a>
                        <p style="margin: 0; font-size: 14px; color: gray;">{{ selectedUser?.email }}</p>
                    </div>
                </div>
                <button class="send-msg-btn" style="margin-left: auto;align-items: flex-start;">
                    <mat-icon>send</mat-icon>
                    <span style="vertical-align: top; padding-left: 3px;">Send Message</span>
                </button>
            </div>
            <div class="user-details-container" *ngIf="selectedCompany"
                style="display: flex; align-items: center; gap: 10px;  padding: -3px 100px;position: relative;">
                <button class="remove-icon" (click)="removesearch()">
                    <mat-icon>close</mat-icon>
                </button>
                <div style="display: flex; gap: 16px; align-items: center;">
                    <!-- Profile Image -->
                    <ng-container *ngIf="selectedCompany.profile_image?.url; else checkLogo">
                        <img [src]="selectedCompany?.profile_image.url" alt="User Image"
                            style="width: 40px; height: 40px; border-radius: 50%;" />
                    </ng-container>
                    <!-- Logo (if no profile image) -->
                    <ng-template #checkLogo>
                        <ng-container *ngIf="selectedCompany.logo?.url; else showInitials">
                            <img [src]="selectedCompany?.logo.url" alt="User Logo"
                                style="width: 40px; height: 40px; border-radius: 50%;" />
                        </ng-container>
                    </ng-template>
                    <!-- Fallback Initials (if no image or logo) -->
                    <ng-template #showInitials>
                        <div class="fallback-avatar">
                            {{ getInitials(selectedCompany.name) }}
                        </div>
                    </ng-template>
                    <div style="display: flex; flex-direction: column;">
                        <a>
                            <!-- <a> -->
                            <h6 class="user-name-detail" (click)="goToDetails(selectedCompany)"> {{
                                selectedCompany.company_name }}
                            </h6>
                        </a>
                        <p style="margin: 0; font-size: 14px; color: gray;">{{ selectedCompany.email }}</p>
                    </div>
                </div>
                <button class="send-msg-btn" style="margin-left: auto;">
                    <mat-icon>send</mat-icon>
                    <span style="vertical-align: top; padding-left: 3px;">Send Message</span>
                </button>
            </div>
        </div>
        <div class="feed_left_column" fxLayout="column" fxFlex.xl="24" fxFlex.lg="24" fxFlex.md="100" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill>

            <div class="feed_search_details ">

                <div class="form_search">
                    <div class="form-section">
                        <div class="custom-form-group">
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline">
                                    <input matInput placeholder="Search" name="search" autocomplete="off"
                                        [(ngModel)]="displayQuery"
                                        (input)="searchQuery = displayQuery; filterUsers($event)" />
                                    <button class="search_btn">
                                        <img src="assets/images/icons/searchN.png" alt="search icon" />
                                    </button>
                                </mat-form-field>
                            </div>
                        </div>
                        <!-- Filtered Users Section -->
                        <div class="filtered-results-container" *ngIf="searchQuery">
                            <div class="filtered-results">
                                <!-- Display dental users and businesses -->
                                <mat-list class="user_chat_lists customeScroll scrollable-list">
                                    <mat-list-item *ngFor="let user of getAllFilteredResults()"
                                        (click)="selectEntity(user, 'user')">
                                        <div class="ravtr" matListAvatar>
                                            <ng-container *ngIf="user.logo?.url; else checkProfileImage">
                                                <img [src]="user.logo.url" alt="{{ user.name }}" />
                                            </ng-container>
                                            <ng-template #checkProfileImage>
                                                <ng-container *ngIf="user.profile_image?.url; else showInitials">
                                                    <img [src]="user.profile_image.url" alt="{{ user.name }}" />
                                                </ng-container>
                                            </ng-template>
                                            <ng-template #showInitials>
                                                <div class="fallback-avatar">
                                                    {{ getInitials(user.name) }}
                                                </div>
                                            </ng-template>
                                        </div>
                                        <p mat-line style="text-align: start;">{{ user.name }}</p>
                                        <button mat-stroked-button class="followBtn"
                                            [disabled]="['PENDING', 'APPROVED'].includes(getStoredFollowStatus(user) || '')"
                                            (click)="followUser(user, $event)">
                                            {{ getFollowButtonLabel(user) }}
                                        </button>

                                    </mat-list-item>
                                    <mat-list-item *ngFor="let company of filteredCompanyNames"
                                        (click)="selectEntity(company, 'company')">
                                        <div class="ravtr" matListAvatar>
                                            <ng-container *ngIf="company.logo?.url; else checkProfileImage">
                                                <img [src]="company.logo.url" alt="{{ company.name }}" />
                                            </ng-container>
                                            <ng-template #checkProfileImage>
                                                <ng-container *ngIf="company.profile_image?.url; else showInitials">
                                                    <img [src]="company.profile_image.url" alt="{{ company.name }}" />
                                                </ng-container>
                                            </ng-template>
                                        </div>
                                        <p mat-line style="text-align: start;">{{ company.company_name }}</p>
                                        <!-- <button mat-stroked-button class="followBtn">Follow</button> -->
                                        <!-- <button mat-stroked-button class="followBtn"
                                        (click)="followUser(company, $event)"
                                        [disabled]="company.followStatus === 'APPROVED' || company.followStatus === 'PENDING'">
                                        {{ company.followStatus === 'APPROVED' ? 'Following' : (company.followStatus
                                        ===
                                        'PENDING' ? 'Pending' : 'Follow') }}
                                    </button> -->
                                        <button mat-stroked-button class="followBtn"
                                            [disabled]="['PENDING', 'APPROVED'].includes(getStoredFollowStatus(company) || '')"
                                            (click)="followUser(company, $event)">
                                            {{ getFollowButtonLabel(company) }}
                                        </button>

                                        <!-- <button mat-stroked-button class="followBtn"
                                        [disabled]="getStoredFollowStatus(company) === 'PENDING'"
                                        (click)="followUser(company, $event, 'COMPANY')">
                                        {{ getFollowButtonLabel(company) }}
                                    </button> -->
                                    </mat-list-item>
                                </mat-list>
                                <!-- No Results Found for users or companies -->
                                <div class="no-results-container" *ngIf="noResultsFound" style="margin-top: 10px;">
                                    <p class="no-results">No results found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="feed_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="column" fxLayout.sm="column"
        fxLayout.xs="column" fxLayoutAlign="start stretch">

        <div class="feed_right_column" fxLayout="column" fxFlex.xl="76" fxFlex.lg="70" fxFlex.md="100" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill>
            <div class="feed_right">


                <div *ngIf="!showpending">
                    <div *ngIf="!mainMenu">
                        <ng-container *ngIf="followingIds">
                            <app-follow-listing [following]="followingIds"
                                [identifyName]="identifyName"></app-follow-listing>
                        </ng-container>

                        <ng-container *ngIf="followersIds">
                            <app-follow-listing [followers]="followersIds"
                                [identifyName]="identifyName"></app-follow-listing>
                        </ng-container>
                    </div>
                </div>



                <div *ngIf="mainMenu">

                    <div class="ParentSatus" [hidden]="selectedUser" [hidden]="selectedCompany"
                        *ngIf="['ADMIN'].includes(loginDetails.type) && !(selectedUser || selectedCompany)">
                        <div class="status-box pending" [class.active]="activeStatus === 'PENDING'"
                            (click)="setActiveStatus('PENDING')">
                            Pending Approval
                            <span class="count">{{ pendingCount }}</span>
                        </div>

                        <div class="status-box published" [class.active]="activeStatus === 'PUBLISHED'"
                            (click)="setActiveStatus('PUBLISHED')">
                            Published
                            <span class="count">{{ publishedCount }}</span>
                        </div>

                        <div class="status-box unpublished" [class.active]="activeStatus === 'UNPUBLISHED'"
                            (click)="setActiveStatus('UNPUBLISHED')">
                            Unpublished
                            <span class="count">{{ unpublishedCount }}</span>
                        </div>
                    </div>

                    <!-- <ng-container *ngIf="newsfeeds || selectedCategory; else loadingTemplate">
                        <ng-container *ngIf="newsfeeds.length ; else noDataTemplate">
                            <div scrollTracker (scrollingFinished)="onScrollingFinished()" style="padding: 0px 32px">
                                <div class="feed_box" *ngFor="let feed of newsfeeds;let i = index">
                                    <div class="feed_box_container">
                                        <app-single-feed [feed]="feed" [selectedCategory]="selectedCategory"
                                            [selectedUser]="selectedUser" [selectedCompany]="selectedCompany"
                                            [commentShows]="commentShow" (scrollingFinished)="onScrollingFinished()"
                                            (feedStatusChanged)="handleFeedStatusChange($event)"></app-single-feed>

                                    </div>

                                </div>

                            </div>


                            <div fxLayout="row" fxLayoutAlign="center center">
                                <p class="no-feed">No more news feed to load</p>
                            </div>
                        </ng-container>

                    </ng-container> -->

                    <div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="180"
                        [scrollWindow]="true" (scrolled)="onScroll($event)">

                        <!--  Main condition: Show loadingTemplate if nothing is selected or loaded -->
                        <ng-container *ngIf="newsfeeds || selectedCategory; else loadingTemplate">

                            <!--  Show loader GIF if data is being fetched -->
                            <ng-container *ngIf="isLoadingFeeds; else feedListTemplate">
                                <div class="custom-loader custom_logo_loader feed_loader">
                                    <img src='../../../../../assets/images2/loader.gif' alt="loading..."
                                        loading="lazy" />
                                </div>
                            </ng-container>

                        </ng-container>
                    </div>

                    <!--  Template to show after loading is complete -->
                    <ng-template #feedListTemplate>
                        <ng-container *ngIf="newsfeeds.length > 0; else noDataTemplate">
                            <!--  Actual feed list -->
                            <div class="NewsFeedBox">
                                <ng-container
                                    *ngFor="let feed of newsfeeds; trackBy: trackByfeedId; let i = index; let last = last">
                                    <div class="feed_box">
                                        <div class="feed_box_container">
                                            <app-single-feed [feed]="feed" [selectedCategory]="selectedCategory"
                                                [selectedUser]="selectedUser" [selectedCompany]="selectedCompany"
                                                [commentShows]="commentShow"
                                                (feedStatusChanged)="handleFeedStatusChange($event)">
                                            </app-single-feed>
                                        </div>
                                    </div>

                                    <!--  Banner after every 5th feed or at the end of short feeds -->
                                    <div *ngIf="listViewBannerData?.length">
                                        <ng-container *ngIf="(i + 1) % 5 === 0 || ((newsfeeds?.length <= 5) && last)">
                                            <section class="banner-container1">
                                                <swiper [config]="listViewRandomSwiperConfig(i)" class="banner-swiper1">
                                                    <div *ngFor="let banner of listViewBannerData" swiperSlide
                                                        #listViewSlide>
                                                        <div class="banner-wrapper1">
                                                            <a [href]="banner.url" target="_blank"
                                                                rel="noopener noreferrer">
                                                                <img class="banner-image1" style="border-radius: 20px;"
                                                                    [src]="banner.img?.url" [alt]="banner.img.name" />
                                                            </a>
                                                            <div class="sponsored-label">
                                                                <span class="info-icon">i</span> Sponsored
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="swiper-pagination"></div>
                                                </swiper>
                                            </section>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>

                            <!--  Spinner while scrolling and loading more feeds -->
                            <div *ngIf="loading" class="loading-spinner" fxLayout="row" fxLayoutAlign="center center">
                                <img src="../../../../../assets/images2/loader.gif" alt="Loading..." loading="lazy"
                                    width="190px" />
                            </div>

                            <!--  End message -->
                            <div *ngIf="noMoreData" class="no-feed" fxLayout="row" fxLayoutAlign="center center">
                                <p>No more news feed to load</p>
                            </div>
                        </ng-container>
                    </ng-template>

                    <!--  No data found -->
                    <ng-template #noDataTemplate>
                        <div class="no-data mt-20 mb-20">
                            <img src='../../../../../assets/images/empty-imgs/no_data_found.gif' alt="img"
                                loading="lazy" />
                        </div>
                    </ng-template>

                    <!--  No category or newsfeeds initially -->
                    <ng-template #loadingTemplate>
                        <div class="custom-loader custom_logo_loader feed_loader">
                            <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="showpending">
                    <div class="user-details-container" *ngFor="let user of visibleAll"
                        style="display: flex; align-items: center; gap: 10px; margin-top: 10px; margin-bottom: 20px; padding: -3px 100px; position: relative;">
                        <!-- <button class="remove-icon" (click)="removesearch(user)">
                            <mat-icon>close</mat-icon>
                        </button> -->

                        <div style="display: flex; gap: 16px; align-items: center;">
                            <!-- Profile Image -->
                            <ng-container *ngIf="user?.profile_image?.url; else checkLogo">
                                <img [src]="user.profile_image.url" alt="User Image"
                                    style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain;" />
                            </ng-container>

                            <!-- Logo (if no profile image) -->
                            <ng-template #checkLogo>
                                <ng-container *ngIf="user?.logo?.url; else showInitials">
                                    <img [src]="user.logo.url" alt="User Logo"
                                        style="width: 40px; height: 40px; border-radius: 50%;" />
                                </ng-container>
                            </ng-template>

                            <!-- Fallback Initials (if no image or logo) -->
                            <ng-template #showInitials>
                                <div class="fallback-avatar">
                                    {{ getInitials(user?.name) }}
                                </div>
                            </ng-template>

                            <div style="display: flex; flex-direction: column;">
                                <a (click)="goToDetails(user)">
                                    <h6 class="user-name-detail">{{ user?.name }}</h6>
                                </a>
                                <p style="margin: 0; font-size: 14px; color: gray;">
                                    {{ user?.email }}
                                </p>
                            </div>
                        </div>

                        <!-- Accept & Decline Buttons -->
                        <div style="margin-left: auto; display: flex; gap: 8px;">
                            <!-- <button class="accept-button" (click)="approve(user)"
                                style="background: linear-gradient(to right, #00c6ff, #0072ff); color: white; border: none; border-radius: 4px; padding: 6px 12px; cursor: pointer;">
                                Accept
                            </button> -->
                            <button class="accept-button" (click)="approve(user)" style="color: white; border: none; border-radius: 4px; padding: 6px 12px; cursor: pointer;
                            background-image: linear-gradient(to right, #fa1d72, #fca300) !important;
                            ">
                                Accept
                            </button>
                            <button class="decline-button" (click)="reject(user)"
                                style="background: linear-gradient(to right, #ff4e50, #f9d423); color: white; border: none; border-radius: 4px; padding: 6px 12px; cursor: pointer;">
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="feed_left_column" fxLayout="column" fxFlex.xl="24" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill>

            <div *ngFor="let user of visibleFollowRequests" class="follow-request-card">
                <mat-card class="request-card">
                    <div style="display: flex
                    ;
                        justify-content: center;
                        align-items: flex-start;">
                        <div class="user_img">
                            <img [src]="getUserImage(user)" alt="User Profile" class="profile-img"
                                style="object-fit: contain;" />
                        </div>
                        <div class="user-infos">
                            <div class="username">
                                {{ user.name }} wants to join your network.
                            </div>

                            <span *ngIf="!showAll && followRequests.length > 0" class="see-All" (click)="seeAll()">
                                See all
                            </span>
                        </div>

                    </div>
                    <div class="buttons" style=" margin: 10px 0px; display: flex; justify-content: center; gap: 20px;">
                        <button mat-raised-button class="accept-btn" (click)="approve(user)" style="
                            background-image: linear-gradient(to right, #fa1d72, #fca300) !important;
                            ">
                            <mat-icon>check</mat-icon> <span>Accept</span>
                        </button>
                        <button mat-raised-button class="decline" (click)="reject(user)" style="
                            background-image: linear-gradient(to right, #fa1d72, #fca300) !important;color: white;
                            ">
                            <mat-icon>close</mat-icon> <span>Decline</span>
                        </button>
                    </div>

                    <!-- Show See All only on the first card if there are more -->

                </mat-card>

            </div>

            <!----online user -->
            <!-- Suggested Dental Business Section -->
            <!-- <div>
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Dental Business</h4>
                    <mat-list class="user_chat_list customeScroll scrollable-list">
                        <mat-list-item *ngFor="let business of notFollowedBusinesses" (click)="goToDetails(business)">
                            <div class="ravtr" matListAvatar>
                                <ng-container *ngIf="business.logo?.url; else initialsBusiness">
                                    <img [src]="business.logo.url" alt="{{ business.name }}" />
                                </ng-container>
                                <ng-template #initialsBusiness>
                                    <div class="fallback-avatar">
                                        {{ getInitials(business.name) }}
                                    </div>
                                </ng-template>
                            </div>
                            <p mat-line>{{ business.name }}</p>
                            <button mat-stroked-button class="followBtn" (click)="followUser(business, $event)">
                                {{ getFollowButtonLabel(business) }}
                            </button>
                        </mat-list-item>
                    </mat-list>
                </div>
               
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Dental Practices</h4>
                    <mat-list class="user_chat_list customeScroll scrollable-list">
                        <mat-list-item *ngFor="let practice of notFollowedDentalPractice" (click)="goToDetails(practice)">
                            <div class="ravtr" matListAvatar>
                                <ng-container *ngIf="practice.logo?.url; else initialsPractice">
                                    <img [src]="practice.logo.url" alt="{{ practice.name }}" />
                                </ng-container>
                                <ng-template #initialsPractice>
                                    <div class="fallback-avatar">
                                        {{ getInitials(practice.name) }}
                                    </div>
                                </ng-template>
                            </div>
                            <p mat-line>{{ practice.name }}</p>
                            <button mat-stroked-button class="followBtn" (click)="followUser(practice, $event)">
                                {{ getFollowButtonLabel(practice) }}

                            </button>
                        </mat-list-item>
                    </mat-list>
                </div>
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Dental Professionals</h4>
                    <mat-list class="user_chat_list customeScroll scrollable-list">
                        <mat-list-item *ngFor="let professional of notFollowedDentalProfessionals" (click)="goToDetails(professional)">
                            <div class="ravtr" matListAvatar>
                                <ng-container *ngIf="professional.profile_image?.url; else initialsProfessional">
                                    <img [src]="professional.profile_image.url" alt="{{ professional.name }}" />
                                </ng-container>
                                <ng-template #initialsProfessional>
                                    <div class="fallback-avatar">
                                        {{ getInitials(professional.name) }}
                                    </div>
                                </ng-template>
                            </div>
                            <p mat-line>{{ professional.name }}</p>
                            <button mat-stroked-button class="followBtn" (click)="followUser(professional, $event)">
                                {{ getFollowButtonLabel(professional) }}

                            </button>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div> -->
            <!-- ----------- -->
            <div>
                <div class="addSection" *ngIf="rightNavBannerData?.length">
                    <swiper [config]="rightNavBNSwiperConfig" class="banner-swiper">
                        <div *ngFor="let banner of rightNavBannerData" swiperSlide #rightNavSlide>
                            <div class="banner-wrapper">

                                <a [href]="banner.url" target="_blank" rel="noopener noreferrer">
                                    <img class="banner-image" [src]="banner.img?.url" [alt]="banner.img.name" />
                                </a>

                            </div>
                        </div>

                        <div class="swiper-pagination"></div>
                    </swiper>
                </div>
                <!-- Suggested Dental Businesses -->
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Business</h4>
                    <div class="user_chat_list customeScroll scrollable-list" infiniteScroll
                        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150" [scrollWindow]="false"
                        (scrolled)="SuggestedBusiness()">
                        <mat-list>
                            <mat-list-item *ngFor="let business of notFollowedBusinesses; trackBy: trackByfeedId;"
                                (click)="goToDetails(business)">
                                <div class="ravtr" matListAvatar>
                                    <ng-container *ngIf="business.logo?.url; else initialsBusiness">
                                        <img [src]="business.logo.url" alt="{{ business.name }}" />
                                    </ng-container>
                                    <ng-template #initialsBusiness>
                                        <div class="fallback-avatar">
                                            {{ getInitials(business.name) }}
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="followNameLink">
                                    <p mat-line>{{ business.name }}</p>

                                    <a class="followLink" (click)="followUser(business, $event)">
                                        {{ getFollowLabel(business.followStatus) }}
                                    </a>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>

                <!-- Suggested Dental Practices -->
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Practices</h4>

                    <div class="user_chat_list customeScroll scrollable-list" infiniteScroll
                        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150" [scrollWindow]="false"
                        (scrolled)="loadSuggestedDentalPractice()">
                        <mat-list>
                            <mat-list-item *ngFor="let practice of notFollowedDentalPractice; trackBy: trackByfeedId;"
                                (click)="goToDetails(practice)">
                                <div class="ravtr" matListAvatar>
                                    <ng-container *ngIf="practice.logo?.url; else initialsPractice">
                                        <img [src]="practice.logo.url" alt="{{ practice.name }}" />
                                    </ng-container>
                                    <ng-template #initialsPractice>
                                        <div class="fallback-avatar">
                                            {{ getInitials(practice.name) }}
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="followNameLink">
                                    <p mat-line>{{ practice.name }}</p>
                                    <a class="followLink" (click)="followUser(practice, $event, 'practice')"
                                        [disabled]="practice.followStatus === 'PENDING'">
                                        {{ getFollowLabel(practice.followStatus) }}
                                    </a>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>


                <!-- Suggested Dental Professionals -->
                <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Professionals</h4>
                    <div class="user_chat_list customeScroll scrollable-list" infiniteScroll
                        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150" [scrollWindow]="false"
                        (scrolled)="loadSuggestedDentalProfessionals()">
                        <mat-list>
                            <mat-list-item *ngFor="let professional of notFollowedDentalProfessionals; trackBy: trackByfeedId;"
                                (click)="goToDetails(professional)">
                                <div class="ravtr" matListAvatar>
                                    <ng-container *ngIf="professional.profile_image?.url; else initialsProfessional">
                                        <img [src]="professional.profile_image.url" alt="{{ professional.name }}" />
                                    </ng-container>
                                    <ng-template #initialsProfessional>
                                        <div class="fallback-avatar">
                                            {{ getInitials(professional.name) }}
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="followNameLink">
                                    <p mat-line>{{ professional.name }}</p>
                                    <a class="followLink" (click)="followUser(professional, $event, 'professional')"
                                        [disabled]="professional.followStatus === 'PENDING'">

                                        {{ getFollowLabel(professional.followStatus) }}
                                    </a>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>
            </div>


            <!-- ----------- -->
            <!-- <div class="online_user pad-bgw">
            <div class="my_profile_chat">
                <div class="ravtr" matListAvatar>
                    <img
                        src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772">
                </div>
                <div class="my_profile_chat_stat">
                    <p mat-line>Sasha Cohen</p>
                    <mat-form-field appearance="fill" class="my_status">
                        <mat-select [(ngModel)]="onlineStatus">
                            <mat-option value="online">Online</mat-option>
                            <mat-option value="offline">Offline</mat-option>
                            <mat-option value="away">Away</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div style="text-align: right;">
                    <button mat-stroked-button class="newChatAdd"><svg xmlns="http://www.w3.org/2000/svg" width="9"
                            height="9" viewBox="17 5 9 9">
                            <g data-name="#000000ff">
                                <path
                                    d="M25.039 5h.057a.945.945 0 0 1 .904.887v.074a.962.962 0 0 1-.312.677c-.16.16-.32.321-.481.48-.442-.44-.884-.883-1.326-1.325.178-.177.355-.356.534-.532A.946.946 0 0 1 25.039 5Z"
                                    fill="#fff" fill-rule="evenodd" data-name="Path 43463" />
                                <path
                                    d="M23.21 6.464c.093-.09.181-.184.275-.271.44.44.88.882 1.322 1.321-.15.161-.31.312-.464.47l-2.496 2.495a.235.235 0 0 1-.138.064c-.433.085-.865.175-1.298.258-.119.023-.236-.093-.212-.212.085-.44.175-.88.262-1.319a.202.202 0 0 1 .06-.116l2.69-2.69Z"
                                    fill="#fff" fill-rule="evenodd" data-name="Path 43464" />
                                <path
                                    d="M17.183 7.012c.2-.309.556-.51.924-.512h3.025a.375.375 0 0 1 .155.713c-.086.044-.185.037-.279.037h-2.883a.376.376 0 0 0-.375.37v5.254a.377.377 0 0 0 .377.376h5.254a.377.377 0 0 0 .369-.374V9.993c0-.087-.008-.177.027-.258a.376.376 0 0 1 .698.005c.032.08.024.168.025.252v2.884A1.132 1.132 0 0 1 23.427 14h-5.365A1.14 1.14 0 0 1 17 12.938v-5.38c.016-.194.074-.385.183-.546Z"
                                    fill="#fff" fill-rule="evenodd" data-name="Path 43465" />
                            </g>
                        </svg>New</button>
                </div>
            </div>
                <div class="search_box">
                    <div class="form_search">
                      <div class="form-section">
                        <div class="custom-form-group">
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <input matInput placeholder="Search"  matInput name="search">
                               
                             
                              <button class="search_btn" mat-button>
                                <img src="../../../../../assets/images/icons/searchN.svg" alt="search icon">
                              </button>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                </div> -->

            <!----suggested frients -->

            <!-- <div class="suggested_friends pad-bgw">
                    <h4 class="box_headingN">Suggested Friends</h4>




                    <mat-list>
                        <mat-list-item>
                           
                            <div class="ravtr" matListAvatar><img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> </div>
                            <p mat-line>Naresh gogula</p> 
                            <button mat-stroked-button class="followBtn">Follow</button>
                        </mat-list-item>
                        <mat-list-item>
                           
                            <div class="ravtr" matListAvatar><img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> </div>
                            <p mat-line>Naresh gogula</p> 
                            <button mat-stroked-button class="followBtn">Follow</button>
                        </mat-list-item>
                        <mat-list-item>
                           
                            <div class="ravtr" matListAvatar><img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> </div>
                            <p mat-line>Naresh gogula</p> 
                            <button mat-stroked-button class="followBtn">Follow</button>
                        </mat-list-item>
                        <mat-list-item>
                           
                            <div class="ravtr" matListAvatar><img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> </div>
                            <p mat-line>Naresh gogula</p> 
                            <button mat-stroked-button class="followBtn">Follow</button>
                        </mat-list-item>
                        <mat-list-item>
                           
                            <div class="ravtr" matListAvatar><img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> </div>
                            <p mat-line>Naresh gogula</p> 
                            <button mat-stroked-button class="followBtn">Follow</button>
                        </mat-list-item>
                       
                       </mat-list>
                       




                    </div> -->
            <!----suggested frients end-->
            <!----online user -->
            <!-- <div class="online_user pad-bgw">
                        <div class="my_profile_chat">
                            
                               
                                <div class="ravtr" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <div class="my_profile_chat_stat"><p mat-line>Sasha Cohen</p> 
                                    <mat-form-field appearance="fill" class="my_status">
        
                                        <mat-select [(ngModel)]="onlineStatus" >
                                         
                                          <mat-option value="online" >Online</mat-option>
                                          <mat-option value="offline">Offline</mat-option>
                                          <mat-option value="away">Away</mat-option>
                                        </mat-select>
                                       
                                       
                                      </mat-form-field>


                                 
                            </div>
                                <div style="text-align: right;">
                                    <button mat-stroked-button class="newChatAdd"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="17 5 9 9"><g data-name="#000000ff"><path d="M25.039 5h.057a.945.945 0 0 1 .904.887v.074a.962.962 0 0 1-.312.677c-.16.16-.32.321-.481.48-.442-.44-.884-.883-1.326-1.325.178-.177.355-.356.534-.532A.946.946 0 0 1 25.039 5Z" fill="#fff" fill-rule="evenodd" data-name="Path 43463"/><path d="M23.21 6.464c.093-.09.181-.184.275-.271.44.44.88.882 1.322 1.321-.15.161-.31.312-.464.47l-2.496 2.495a.235.235 0 0 1-.138.064c-.433.085-.865.175-1.298.258-.119.023-.236-.093-.212-.212.085-.44.175-.88.262-1.319a.202.202 0 0 1 .06-.116l2.69-2.69Z" fill="#fff" fill-rule="evenodd" data-name="Path 43464"/><path d="M17.183 7.012c.2-.309.556-.51.924-.512h3.025a.375.375 0 0 1 .155.713c-.086.044-.185.037-.279.037h-2.883a.376.376 0 0 0-.375.37v5.254a.377.377 0 0 0 .377.376h5.254a.377.377 0 0 0 .369-.374V9.993c0-.087-.008-.177.027-.258a.376.376 0 0 1 .698.005c.032.08.024.168.025.252v2.884A1.132 1.132 0 0 1 23.427 14h-5.365A1.14 1.14 0 0 1 17 12.938v-5.38c.016-.194.074-.385.183-.546Z" fill="#fff" fill-rule="evenodd" data-name="Path 43465"/></g></svg>New</button>
                                </div>
                            
                        </div>


                        <div class="search_box">
                            <div class="form_search">
                              <div class="form-section">
                                <div class="custom-form-group">
                                  <div class="custom-form-control">
                                    <mat-form-field appearance="outline">
                                      <input matInput placeholder="Search"  matInput name="search">
                                       
                                     
                                      <button class="search_btn" mat-button>
                                        <img src="../../../../../assets/images/icons/searchN.svg" alt="search icon">
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
    
    
    
                        <mat-list class="user_chat_list customeScroll">
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_online" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">Typing …</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">08:05</p>
                                    <span class="msgCount">5</span>
                                </div>
                            </mat-list-item>
                           
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_online" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_away" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_away" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            <mat-list-item>
                               
                                <div class="ravtr user_online_status now_offline" matListAvatar>
                                    <img  src="https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360Internal/project/223f0555-03ec-4b44-a1dd-25fcba367772"> 
                                    
                                </div>
                                <p mat-line>Sasha Cohen</p> 
                                <p mat-line class="activeText">That was wonderful. Thanks…</p> 
                                <div style="text-align: right;">
                                    <p class="lastOnlineTime">01.02.21</p>
                                    
                                </div>
                            </mat-list-item>
                            
                           
                           </mat-list>
                           
    
    
    
    
                        </div> -->
            <!----online user end -->
        </div>

    </div>
    <!-- Display user details if selectedUser exists -->
    <div *ngIf="selectedUser">
        <app-single-feed [selectedUser]="selectedUser"></app-single-feed>
    </div>
    <!-- Display company details if selectedCompany exists -->
    <div *ngIf="selectedCompany">
        <app-single-feed [selectedCompany]="selectedCompany"></app-single-feed>
    </div>
</section>